// PWA service worker registration + tiny helpers.
// Skips registration in unsupported / dev "localhost http" contexts is unnecessary here
// because the preview URL is served over HTTPS.

let registrationPromise = null;

export const registerSW = () => {
  if (typeof window === "undefined") return null;
  if (!("serviceWorker" in navigator)) return null;
  if (registrationPromise) return registrationPromise;
  registrationPromise = navigator.serviceWorker
    .register("/service-worker.js", { scope: "/" })
    .catch((err) => {
      console.warn("[SW] registration failed:", err);
      return null;
    });
  return registrationPromise;
};

// Ask the active SW to cache a set of URLs eagerly. Returns a Promise that resolves
// with { ok: number, fail: number } after the SW reports back.
export const precacheUrls = async (urls = []) => {
  if (!("serviceWorker" in navigator)) return { ok: 0, fail: urls.length };
  const reg = await registerSW();
  const sw = reg?.active || navigator.serviceWorker.controller;
  if (!sw) return { ok: 0, fail: urls.length };

  return new Promise((resolve) => {
    const channel = new MessageChannel();
    const timeoutId = setTimeout(() => {
      try { channel.port1.close(); } catch {}
      resolve({ ok: 0, fail: urls.length, timeout: true });
    }, 60000);
    const onMsg = (e) => {
      if (e.data?.type === "PRECACHE_DONE") {
        clearTimeout(timeoutId);
        const ok = e.data.results.filter((r) => r.ok).length;
        navigator.serviceWorker.removeEventListener("message", onMsg);
        resolve({ ok, fail: urls.length - ok });
      }
    };
    navigator.serviceWorker.addEventListener("message", onMsg);
    sw.postMessage({ type: "PRECACHE_URLS", urls });
  });
};

// Quick reachable check (network up?).
export const isOnline = () =>
  typeof navigator !== "undefined" ? !!navigator.onLine : true;
